<ngx-spinner type="ball-beat" bdColor="rgba(0,0,0,.5)" size="large">
  <ng-container *ngIf="loaderText">{{ loaderText }}</ng-container>
</ngx-spinner>